<h1 class="modal__header">Cancel Policy</h1>
<div *ngIf="!submitted">
  <div class="modal__text" *ngIf="!submitted">
    <p>Are you sure you want to cancel your policy?</p>
  </div>
  <div class="modal__actions">
    <a *ngIf="href" class="button button--blue button--primary modal__button" href="{{ href }}">
      YES, PLEASE CANCEL MY POLICY
    </a>
    <a *ngIf="!href" class="button button--blue button--primary modal__button" (click)="cancelPolicy()">
      YES, PLEASE CANCEL MY POLICY
    </a>
  </div>
  <div class="modal__link-text">
    <span (click)="closeModal()">No, do not cancel my policy</span>
  </div>
</div>
<div *ngIf="submitted">
  <div class="modal__text" *ngIf="submitted">
    <p>
      We've received your cancellation request. Please allow up to 10 business days for us to confirm the cancellation.
      Any funds withdrawn will be returned to your bank account on record.
    </p>
  </div>
</div>
